import { render, staticRenderFns } from "./PdpXsellCarousel.vue?vue&type=template&id=db8fc884&lang=pug&"
import script from "./PdpXsellCarousel.vue?vue&type=script&lang=js&"
export * from "./PdpXsellCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PdpXsellCarousel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports